/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */

import { OusterProvider } from '@ouster/webviz-react-components';

import * as Sentry from '@sentry/react';
import { StoreProvider as EzPzProvider } from 'easy-peasy';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider } from 'styled-components/macro';

import App from './App';
import { ousterLogoAscii } from './images/OusterLogoAscii';
import { getOusterWasmBytes } from './sdkWebPreload';
import * as serviceWorker from './serviceWorker';
import makeStore from './store';
import { darkTheme } from './Theme';
// Initialize singletons
import { registerStore as registerStoreForLogging } from './utils/log';
import { registerStoreForAuth } from './utils/requests';

const store = makeStore();
registerStoreForLogging(store);
registerStoreForAuth(store);

console.log(ousterLogoAscii);
console.log("We're hiring! https://ouster.com/careers/");

// SDK Web Wasm preload: fetch wasm bytes
getOusterWasmBytes().catch((e) => {
  console.error('Failed to preload Ouster SDK Web:', e);
});

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

/* 
  We don't want to initialize Sentry in development mode.
  But we do want to separate staging and production environments.
*/
if (process.env.NODE_ENV === 'production') {
  const sentryEnv = window.location.hostname.includes('studio.staging')
    ? 'staging'
    : 'production';

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: '9',
    environment: sentryEnv,
    sendDefaultPii: true,
    integrations: [],
    initialScope: {
      tags: { app: 'osw' },
    },
  });
}

root.render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
    <ReduxProvider store={store}>
      <EzPzProvider store={store}>
        <ThemeProvider theme={darkTheme}>
          <OusterProvider>
            <App />
          </OusterProvider>
        </ThemeProvider>
      </EzPzProvider>
    </ReduxProvider>
  </Sentry.ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
